import {NgModule} from '@angular/core';
import {EmailInputComponent} from './email-input.component';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {InputTextModule} from '../../../../core/component/input-text/input-text.module';

@NgModule({
    imports: [
        IonicModule,
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        InputTextModule,
    ],
    declarations: [
        EmailInputComponent,
    ],
    exports: [
        EmailInputComponent
    ],
})
export class EmailInputModule {
}
